module.exports = __webpack_public_path__ + "assets/img/g4.1a56d6c1.jpg";